import { atom, useAtom, useSetAtom } from "jotai";

export const modalAtom = atom("");

const useLiveModal = () => {
  return useAtom(modalAtom);
};

export const useSetLiveModal = () => useSetAtom(modalAtom);

export default useLiveModal;
